<template>
  <div class='h-topogjxx-sidebj'>
<div class='h-toolbarBg h-topo-margin'>

            <div :class='[hasBorder ? "h-borderBox-top" : "h-inputBox"]' >
                <div :class='{"col-xs-12 col-sm-12 col-lg-12 col-md-12": hasBorder}' >
                    <ejs-textbox :placeholder='$t("System.inputTip7")' @keydown.enter.native="search" v-model='input' />
                </div>
            </div>
        </div>
    <ejs-grid :dataSource='fmData' ref='grid' :class=' { "h-borderBox-content": hasBorder }'>
      <e-columns>
      <!-- TODO field 需要变 -->
        <e-column field='alarmID' :headerText='$t("Alarm.alarmID")' textAlign='Center' width='6%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='alarmName' :headerText='$t("Alarm.alarmName")' textAlign='Center' width='15%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='levelStr' :headerText='$t("Alarm.alarmLevel")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='levelFormat'></e-column>
        <e-column field='equipmentName' :headerText='$t("Alarm.equipmentName")' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neName' :headerText='$t("Alarm.neName")' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neAlarmFDN' :headerText='$t("Alarm.neAlarmFDN")' textAlign='Center' width='11%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='clearStateStr' :headerText='$t("Alarm.clearState")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter='clearFormat'></e-column>
   </e-columns>
    </ejs-grid>
  </div>
</template>

<script>
let dataSource = [];
export default {
  name: 'AlarmShowDialog',
   props: [
    'hasBorder'  ],

  data() {
    return {
      input:'',
       page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0
      },
      queryConditions: {
        systemId: '1',
        conditions: '', // 告警过滤时会有查询条件，筛调部分告警，初始化时需获取初始条件
        keywords: '', // 模糊查询关键字
      },
      fmData: [],
      roleNetList : [],
      roleNe:[],
      conditions: {
        alarmTime: {
          createTime: '',
          clearTime: '',
          confirmTime: ''
        },
        alarmLevel: [],
        alarmType: [],
        nodeIds: [],
        ne: [],
        alarmState:{
          clearState: 0,
          confirmState: ''
        }
      },
    }
  },
  methods: {
        clearFormat(grid, data) {
      return this.$t(`Alarm.alarmClearStatus_${data.clearState}`);
    },
        levelFormat(grids, data) {
      return `<span class='h-alarmLevel${data.level}'>${this.$t(`Alarm.alarmLevel_${data.level}`)}</span>`;
    },
      beforeMount(id) {
    const This = this;
    this.$loading.showLoadding(this.$t('Software.Searching'));
    This.$axios.get('/lte/ems/auth/findNodeIdByAuth').then((response) => {
      if (response && response.status === 200) {
        for (let i = 0; i < response.data.length; i++) {
          This.roleNetList.push(response.data[i]);
        }
        this.getAlarmListData(id);
      }
    })
  },
    getAlarmListData(id) {
      const neIds=[10];
      const This = this;
      const l=This.roleNetList;
      if (id instanceof Array) {
        this.conditions.nodeIds = id;
      } else {
        this.conditions.nodeIds = [id];
      }
      This.$axios.post('/lte/ems/fm/alarmcurrent/queryAlarm.html', {
        conditions: JSON.stringify(this.conditions),
        keywords: "",
        roleNe:l
      }).then((response) => {
        if (response && response.status === 200) {
          this.$loading.hideLoadding();
          this.dataSource = response.data.resultVal;
          this.fmData = this.dataSource;
        }
      });
    },

        search(args) {
      if(this.input === '') {
          this.fmData = this.dataSource;
      }
      else {

        var filterdata = this.dataSource.filter( item => {
            let columntext = Array.from(this.$refs.grid.getColumns(), x => {
              return x.field;
            });

            let feildData = Array.from(columntext, x => {
              return item[x] === null ? '' : item[x] +'';
            });
            let filres = false;
            feildData.forEach(item => {
              if(item.indexOf(this.input) > -1)
              {
                filres = true;
              }
            });
            return filres;
        }).map( item => { return item });
        this.fmData = filterdata;

      }
    }
  },
  mounted() {
  },
}
</script>
